export default function ProductsSection() {
  const items = [
    {
      title: "סטיילינג לנערות",
      text: "הרצאה שמותאמת לגיל ההתבגרות, מתמקדת בהכרת מבנה הגוף, פיתוח סגנון אישי, התמודדות עם שינויים בגוף ובטעם האישי, ובניית בטחון עצמי דרך לבוש.",
      imageBackground: "youth.jpg",
      },
    {
      title: "סדנת סטיילינג בת 4 שעות",
      text: "סדנה חווייתית הכוללת היכרות עם עקרונות בסיסיים של סטיילינג – התאמת צבעים, זיהוי מבנה גוף, שילובי בגדים, אקססוריז וטיפים ליצירת מלתחה חכמה ומגוונת.",
    imageBackground: 'four_hours.jpg'
      },
    {
      title: "סטיילינג לנשים אחרי לידה",
        text: "הרצאה שמציעה כלים מעשיים להרגיש טוב עם הגוף אחרי שינויים בעקבות לידה. דגש על התאמת בגדים לתקופה זו, נוחות לצד שיק, והחזרת תחושת הנשיות.",
        imageBackground: "baby.jpg"
      },
    {
      title: "סטיילינג לראיון עבודה / קבלה לעבודה",
      text: "איך ליצור רושם ראשוני מקצועי ונעים באמצעות הלבוש? בהרצאה נעסוק בהתאמת לבוש לתחום העיסוק, שילוב אלמנטים אישיים במראה פורמלי וטיפים לדיוק ההופעה ביום החשוב.",
    imageBackground: 'job.jpg'
    
      },
    {
      title: "מלתחה חכמה לתחילת הדרך התעסוקתית",
      text: "איך בונים מלתחה מגוונת, איכותית ומתאימה לכניסה לשוק העבודה – גם בתקציב מוגבל? הרצאה עם כלים פרקטיים לבחירת פריטים שימושיים, שילובים חכמים והופעה ייצוגית ונעימה.",
  imageBackground:  'child.jpg'
      },
    {
      title: "סטיילינג בפרישה מהעבודה",
      text: "הרצאה שעוסקת בהתחדשות בגיל הבשל – איך לאמץ סגנון שמשדר חופש, ביטחון ובשלות, מבלי לוותר על נוחות ואלגנטיות. התאמת לבוש לאורח חיים חדש.",
   imageBackground: 'retire.jpg'
      },
    {
      title: "מבנה גוף – הכירי את הגוף שלך",
      text: "פירוט על סוגי מבנה גוף (אגס, תפוח, שעון חול וכו') ולמידה איך להתלבש בהתאם כדי להחמיא לצורת הגוף. כלים לזיהוי העצמה אישית דרך לבוש מדויק.",
         imageBackground: 'structure.jpg'
      },
    {
      title: "צבע – מצאי את הצבעים שמחמיאים לך",
      text: "הבנה של תורת הצבעים בהתאמה לגוון העור, השיער והעיניים. ניתוח צבע אישי וטיפים לשילובי צבעים שיעצימו את ההופעה.",
      imageBackground: 'colors.jpg'
      },
    {
      title: "בטן – איך מתלבשים כשזה האזור המאתגר?",
      text: "הרצאה שמתמקדת בטיפים פרקטיים להלבשה מחמיאה כאשר אזור הבטן הוא אזור רגיש. בחירת גזרות, בדים ואקססוריז שיעניקו מראה מחמיא ובטוח.",
          imageBackground: 'belly.jpg'

      },
  ];

  return (
    <section  id='workshops' className="bg-white py-20 px-4 sm:px-8" dir="rtl">
      <div className="max-w-7xl mx-auto text-center mb-12">
        <h2 className="text-4xl md:text-5xl font-extrabold mb-4">
          <span className="bg-pink-500 text-white px-2 rounded">סדנאות</span>{" "}
          <span className="text-pink-500">והרצאות</span>
        </h2>
      </div>

      {/* Product grid */}
<div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto px-4">
  {items.map((item, i) => (
    <div
      key={i}
      className="bg-white rounded-xl shadow-lg overflow-hidden border border-gray-200 flex flex-col"
      dir="rtl"
    >
      {/* Full Image */}
      <img
        src={`/${item.imageBackground}`}
        alt={item.title}
        className="w-full h-64 object-contain bg-gray-100"
      />

      {/* Text Section */}
      <div className="p-6 flex flex-col justify-between flex-grow">
        <h3 className="text-xl font-bold text-pink-600 mb-2">{item.title}</h3>
        <p className="text-gray-700 text-sm mb-6 leading-relaxed">{item.text}</p>
       {/* <button
  className="mt-auto px-4 py-2 text-white rounded-full font-semibold hover:brightness-110 transition"
  style={{ backgroundColor: "#eec0c8" }}
>
  לפרטים נוספים
</button> */}
      </div>
    </div>
  ))}
</div>

    </section>
  );
}